var impressum = "Künye";
var privacy = "Gizlilik ve Mevzuat";
var recallInfo = "Geri Arama Bilgisi";
var signOut = "Oturumu Kapat";
var tr_tr = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { tr_tr as default, impressum, privacy, recallInfo, signOut };
